module.exports = __webpack_public_path__ + "img/clipboardCheck.b110036a.png";